export default __webpack_public_path__ + "static/venue-above-footer-decb88c81aac66eece14be203097a092.jpg";